module.exports = __webpack_public_path__ + "static/media/3.338e5c75.png";